// extracted by mini-css-extract-plugin
export default {"container":"szoT9o","extraMarginTop":"wUZCVL","badgeContainer":"kay1L0","badge":"Tk7k86","date":"TRnkW5","time":"b15rtT","separator":"wk8tIB"};